/**
 * Dropdown — minimal click-to-toggle Dropdown
 *
 * Aktiviert über:
 *   <button data-bs-toggle="dropdown" aria-expanded="false">…</button>
 *   <ul class="dropdown-menu">…</ul>
 *
 * Verhalten:
 *  - Click toggles .show auf .dropdown-menu
 *  - Click außerhalb schließt
 *  - ESC schließt + Focus zurück zum Toggle
 *  - aria-expanded wird gepflegt
 */

let activeMenu = null;
let activeToggle = null;

function close() {
  if (!activeMenu) return;
  activeMenu.classList.remove("show");
  if (activeToggle) activeToggle.setAttribute("aria-expanded", "false");
  activeMenu = null;
  activeToggle = null;
}

function open(toggle) {
  const dropdown = toggle.closest(".dropdown");
  if (!dropdown) return;
  const menu = dropdown.querySelector(".dropdown-menu");
  if (!menu) return;

  if (activeMenu && activeMenu !== menu) close();

  menu.classList.add("show");
  toggle.setAttribute("aria-expanded", "true");
  activeMenu = menu;
  activeToggle = toggle;
}

function handleClick(event) {
  const toggle = event.target.closest('[data-bs-toggle="dropdown"]');
  if (toggle) {
    event.preventDefault();
    event.stopPropagation();
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    if (isOpen) close();
    else open(toggle);
    return;
  }

  if (activeMenu && !event.target.closest(".dropdown")) {
    close();
  }
}

function handleKeydown(event) {
  if (event.key !== "Escape" || !activeMenu) return;
  const toggle = activeToggle;
  close();
  if (toggle && typeof toggle.focus === "function") toggle.focus();
}

export function init() {
  document.addEventListener("click", handleClick);
  document.addEventListener("keydown", handleKeydown);
}
